import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from "react";
import PropTypes from "prop-types";
import ControlWrapper from "./o2-control-wrapper";

function O2ControlSeparator(props) {
  var id = props.id,
      wrapperId = props.wrapperId,
      className = props.className,
      label = props.label,
      labelNote = props.labelNote,
      inline = props.inline,
      inlineVertical = props.inlineVertical,
      inlineLabel = props.inlineLabel,
      indentLeft = props.indentLeft,
      indentRight = props.indentRight,
      indentBottom = props.indentBottom,
      fakeLabel = props.fakeLabel,
      validationText = props.validationText,
      validationType = props.validationType,
      note = props.note,
      wrapperModifiers = props.wrapperModifiers,
      block = props.block,
      attributes = _objectWithoutPropertiesLoose(props, ["id", "wrapperId", "className", "label", "labelNote", "inline", "inlineVertical", "inlineLabel", "indentLeft", "indentRight", "indentBottom", "fakeLabel", "validationText", "validationType", "note", "wrapperModifiers", "block"]);

  return /*#__PURE__*/React.createElement(ControlWrapper, _extends({
    id: wrapperId,
    controlId: id,
    note: note,
    label: label,
    labelNote: labelNote,
    inline: inline,
    block: block,
    inlineVertical: inlineVertical,
    inlineLabel: inlineLabel,
    fakeLabel: fakeLabel,
    wrapperModifiers: wrapperModifiers,
    validationType: validationType,
    validationText: validationText,
    wrapperClassName: className,
    indentLeft: indentLeft,
    indentRight: indentRight,
    indentBottom: indentBottom,
    separator: true
  }, attributes), "\u2013");
}

O2ControlSeparator.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  label: PropTypes.string,
  labelNote: PropTypes.string,
  inline: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(["md"])]),
  inlineVertical: PropTypes.oneOf(["top", "middle", "bottom"]),
  inlineLabel: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(["lg"])]),
  indentLeft: PropTypes.bool,
  indentRight: PropTypes.bool,
  indentBottom: PropTypes.bool,
  fakeLabel: PropTypes.bool,
  validationText: PropTypes.string,
  validationType: PropTypes.oneOf(["error", "warning", "success", false]),
  note: PropTypes.string,
  wrapperId: PropTypes.string,
  wrapperModifiers: PropTypes.string,
  wrapperClassName: PropTypes.string,
  block: PropTypes.bool
};
export default O2ControlSeparator;